import React from 'react'
import useSgReadyBadgeForLiveView from '../hooks/use-sg-ready-badge-for-live-view'
import { useFeatureFlagsContext } from 'src/Libs/feature-flags/FeatureFlagsContext'
import SgReadyBadgeView from './SgReadyBadgeView'

interface Props {
  installationId?: string
  storageId?: string
  isNewLiveValuesEnabled?: boolean
}

const SgReadyBadgeForLiveView: React.FC<Props> = ({ installationId, storageId, isNewLiveValuesEnabled = false }) => {
  const {
    isFeatureFlagsLoading,
    featureFlags: { isSgReadyEnabled },
  } = useFeatureFlagsContext()
  const { isLoading, sgReadyStatus, isDynamicPowerPriceEnabledForFarm, threeSixtyAutarkyHintKey, hideSgReadyBadge } = useSgReadyBadgeForLiveView({
    installationId,
    storageId,
  })

  const showSgReadyBadge = !hideSgReadyBadge && isSgReadyEnabled && !isFeatureFlagsLoading

  return (
    <SgReadyBadgeView
      sgReadyStatus={sgReadyStatus}
      showSgReadyBadge={showSgReadyBadge}
      isDynamicPowerPriceEnabledForFarm={isDynamicPowerPriceEnabledForFarm}
      threeSixtyAutarkyHintKey={threeSixtyAutarkyHintKey}
      isLoading={isLoading}
      isNewLiveValuesEnabled={isNewLiveValuesEnabled}
    />
  )
}

export default SgReadyBadgeForLiveView
